import React, { useContext, useEffect } from 'react';
import { Modal, Table } from 'antd';

import useCategories from '../../../Categories/useCategories';
import ActiveFiltersBar from '../../../../components/ActiveFiltersBar';
import TableCard from '../../../../components/TableCard';
import TableDicaHint from '../../../../components/TableDicaHint';
import TablePagination from '../../../../components/TablePagination';
import { ThemeContext } from '../../../../contexts/ThemeContext';

interface IProps {
    onTotalChange?: (total: number) => void;
}

export default function TabCategories({ onTotalChange }: IProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    const {
        isLoading,
        isLoadingDelete,
        isDeleteModalVisible,
        categoryBeingDeleted,
        columns,
        tableData,
        pagination,
        activeFilterItems,
        handleConfirmDeleteCategory,
        handleCancelDeleteCategory,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        navigate,
    } = useCategories();

    useEffect(() => {
        if (onTotalChange) {
            onTotalChange(tableData.length);
        }
    }, [tableData.length, onTotalChange]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Dê um clique em qualquer linha para editar a categoria ou utilize os botões de ação à direita." />

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={tableData.length}
                itemName="categorias"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="id"
                    className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
                    columns={columns}
                    dataSource={tableData.slice(
                        (pagination.current - 1) * pagination.pageSize,
                        pagination.current * pagination.pageSize
                    )}
                    loading={isLoading}
                    pagination={false}
                    scroll={{ x: 800 }}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                        onClick: () => {
                            navigate(`/categorias/editar/${record.id}`);
                        },
                        style: {
                            cursor: 'pointer',
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={tableData.length}
                itemName="categorias"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />

            {/* Modal de Exclusão de Categoria */}
            <Modal
                title="Confirmar Exclusão"
                open={isDeleteModalVisible}
                onOk={handleConfirmDeleteCategory}
                okButtonProps={{
                    danger: true,
                    loading: isLoadingDelete,
                }}
                cancelButtonProps={{
                    disabled: isLoadingDelete,
                }}
                okText="Excluir Categoria"
                cancelText="Cancelar"
                onCancel={handleCancelDeleteCategory}
                centered
            >
                <div style={{ padding: '12px 0' }}>
                    <p style={{ margin: 0, fontSize: 14 }}>
                        Tem certeza que deseja excluir a categoria{' '}
                        <strong style={{ color: '#ff4d4f' }}>"{categoryBeingDeleted?.name}"</strong>?
                    </p>
                    <p style={{ marginTop: 8, fontSize: 13, color: isDark ? '#a6a6a6' : '#64748b' }}>
                        Recompensas vinculadas a esta categoria precisarão ser reatribuídas caso necessário.
                    </p>
                </div>
            </Modal>
        </div>
    );
}
